import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mprd-patch',
  templateUrl: './patch.component.html',
})
export class PatchComponent implements OnInit {
  @Input() patchShape:
    | 'top-right'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-left';
  @Input() patchType: 'promo' | 'info' | 'blackfriday' | 'eco';
  @Input() customClass = '';
  @Input() isNegative = false;
  @Input() label: string;

  constructor() {}

  ngOnInit(): void {}

  getClass() {
    const shape = this.getShape();
    const color = this.getColour();
    const negativeColor = this.isNegative ? this.getColour() + '-neg' : '';
    return `${shape} ${color} ${negativeColor} ${this.customClass}`;
  }

  getShape() {
    let shape = 'rs-patch-corner';
    switch (this.patchShape) {
      case 'top-right':
        shape += '1';
        break;
      case 'bottom-right':
        shape += '2';
        break;
      case 'bottom-left':
        shape += '3';
        break;
      case 'top-left':
        shape += '4';
        break;
    }
    return shape;
  }

  getColour() {
    return `rs-patch-${this.patchType}`;
  }
}
